import { Component } from '@angular/core';

@Component({
  selector: 'app-manual-login-main',
  templateUrl: './manual-login-main.component.html',
  styleUrls: ['./manual-login-main.component.css']
})
export class ManualLoginMainComponent {

  english:boolean=true;
  hindi:boolean=false;
  ngOnInit(): void {
    const storeVal = localStorage.getItem('selectedValue');
    if (storeVal == 'english') {
      this.english = true;
      this.hindi = false;
    }
    if (storeVal == 'hindi') {

      this.english = false;
      this.hindi = true;
    }

  }
}
